import React from 'react';
import { BelongMainSection } from 'modules/belong-main-section';

const LandingBelong = () => {
  return <BelongMainSection />;
};

export default LandingBelong;
